exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.project-details-screen .project-avatar-big {\n  width: 60px;\n  height: 60px;\n  margin-right: 10px;\n}\n.project-details-screen .project-avatar {\n  width: 40px;\n  height: 40px;\n  margin-right: 10px;\n}\n.project-details-screen .container {\n  max-width: 1000px;\n}\n.project-details-screen .row {\n  margin-bottom: 15px;\n}\n.project-details-screen .fork-info {\n  margin-left: 20px;\n}\n.project-details-screen a {\n  color: inherit;\n  text-decoration: none;\n}\n.project-details-screen a:hover {\n  color: blue;\n}\n.project-details-screen .subheader {\n  font-size: 12px;\n  font-style: italic;\n  color: #666;\n}\n", ""]);

// exports
